import React from "react";

export const CourseHeaderButton = ({url, onClick, text, extraStyling}) => {

  return (
    <div className={extraStyling}>
      <a href={url} onClick={onClick} className="remove_outline_for_a">
        <div className="btsp_bullet_button btn_inline btsp_bullet_button set_outline_for_button">
          <div className="icon">
          <i className="gga-circle-plus"/>
          </div>
          <div className="btsp_align-middle">
            {text}
          </div>
        </div>
      </a>
    </div>
  )
}